import React from 'react'; 
import { motion } from 'framer-motion'; // For smooth animations

const About = () => {
  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '50px 20px',
    background: 'linear-gradient(135deg, #000, #000)', // Black theme gradient
    color: 'white',
    fontFamily: "'Poppins', sans-serif", // Updated font
  };

  const contentStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: '1200px',
    boxShadow: '0 10px 20px rgba(255, 0, 0, 0.3)', // Red shadow for accent
    backgroundColor: 'rgba(255, 255, 255, 0.05)', // Subtle transparency
    borderRadius: '15px',
    overflow: 'hidden',
    margin: '20px',
  };

  const textStyle = {
    flex: 1,
    padding: '30px',
    color: '#f8f9fa',
  };

  const titleStyle = {
    fontSize: '3rem',
    fontWeight: 'bold',
    marginBottom: '20px',
    textAlign: 'center',
    color: '#dc143c', // Red for emphasis
  };

  const headingStyle = {
    fontSize: '2rem',
    color: '#ffd700', // Golden yellow for subheadings
    marginTop: '20px',
  };

  const descriptionStyle = {
    fontSize: '1.2rem',
    lineHeight: '1.8',
    color: '#ccc',
  };

  const imageStyle = {
    width: '100%',
    height: 'auto',
    borderRadius: '0 15px 15px 0',
    animation: 'fadeIn 2s ease',
  };

  const fadeInUp = {
    animation: 'fadeInUp 1.5s ease',
  };

  return (
    <div style={containerStyle}>
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        style={contentStyle}
      >
        <div style={textStyle}>
          <h1 style={{ ...titleStyle, ...fadeInUp }}>Everest Momo Cafe</h1>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1.5 }}
            style={descriptionStyle}
          >
            Everest Momo Cafe embarked on a mission to bring the authentic
            flavors of Nepalese cuisine to Turku, Finland. Our journey began
            with a vision to create a cozy spot where guests could enjoy the
            rich and soulful taste of Nepali momo and other traditional dishes.
          </motion.p>

          <p style={descriptionStyle}>
            From our humble beginnings, Everest Momo Cafe has grown to become a
            favorite destination for both locals and tourists. With a focus on
            quality ingredients and a welcoming atmosphere, we proudly serve an
            array of Nepali dishes, specializing in momo – a beloved street food
            delicacy.
          </p>

          <motion.h2 style={headingStyle}>Vision</motion.h2>
          <p style={descriptionStyle}>
            Our vision is to become the leading ambassador of Nepali cuisine,
            renowned for providing an exceptional gastronomic experience that
            transcends borders.
          </p>

          <motion.h2 style={headingStyle}>Mission</motion.h2>
          <p style={descriptionStyle}>
            Our mission is to serve the authentic, vibrant flavors of Nepali
            cuisine with a focus on momo and traditional dishes, offering a
            dining experience that delights and satisfies.
          </p>

          <motion.h2 style={headingStyle}>Goals</motion.h2>
          <p style={descriptionStyle}>
            Our goal is to expand Everest Momo Cafe's presence beyond Turku,
            bringing the authentic taste of Nepali cuisine to major cities in
            Finland, Europe, and around the world.
          </p>
        </div>
        <div>
          <motion.img
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 1 }}
            src="logo_1-01.png"
            alt="Delicious Nepali Momo"
            style={imageStyle}
          />
        </div>
      </motion.div>
    </div>
  );
};

export default About;
